import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";

import UseFetch from "../components/UseFetch";
import {
    decryptData,
    defaulUrl,
    encryptData,
    formatMoney,
    impression,
    onfocus,
} from "../components/const";

const AddApprovision = () => {
    const { data, isloading } = UseFetch("approvisions/get-data");
    const magasins = data?.magasins || [];
    const conteneurs = data?.conteneurs?.filter((cont) => +cont.statut === 0) || [];

    const conteneurStoraged = decryptData("selectedConteneur");
    const [magasin, setMagasin] = useState(null);
    const [conteneur, setConteneur] = useState(conteneurStoraged || null);
    const [isLoading, setIsLoading] = useState(false);
    const [products, setProducts] = useState(conteneurStoraged?.produits || null);

    const navigate = useNavigate();
    const printElemet = useRef();

    console.log(products)

    /** Annuler et vider */
    const handleCancel = () => {
        setMagasin(null);
        setConteneur(null);
        setProducts(null);
        localStorage.removeItem("selectedConteneur");
    };

    /** Sauvegarde */
    const handleSave = () => {
        let status = 0;
        try {
            if (!magasin) {
                throw new Error("Veuillez sélectionner le magasin à approvisionner");
            }
            products.forEach((prod) => {
                if (!prod.pvu || parseFloat(prod.pvu) < 1) {
                    throw new Error("Vérifiez le prix sur la ligne " + (products.indexOf(prod) + 1));
                }
            });

            setIsLoading(true);
            fetch(`${defaulUrl}approvisions/add`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${decryptData("ACCESS_TOKEN")}`,
                },
                body: JSON.stringify({
                    approvision: {
                        idmagasin: magasin.value,
                        idconteneur: conteneur.value,
                    },
                    produits: products,
                }),
            }).then(respon => {
                setIsLoading(false)
                status = respon.status;
                return respon.json()
            }).then((data) => {
                if (status === 200) {
                    Swal.fire({
                        title: "Succès",
                        text: data.message,
                        icon: "success",
                        showCancelButton: true,
                        confirmButtonText: "Imprimer",
                        cancelButtonText: "Quitter",
                        confirmButtonColor: "green",
                        cancelButtonColor: "red",
                    }).then((confirm) => {
                        if (confirm.isConfirmed) {
                            impression(
                                printElemet.current,
                                "portrait",
                                `APPROVISION | MAGASIN: ${magasin?.label} | CONTENEUR: ${conteneur?.label}`,
                                products,
                                totalQte,
                                conteneur?.montant_achat,
                                totalVente
                            );
                        }
                        handleCancel();
                        navigate("/approvisions");
                    });
                }

            });








        } catch (error) {
            Swal.fire({
                title: "Erreur",
                text: error.message,
                icon: "error",
                toast: true,
                position: "center",
                color: "white",
                iconColor: "white",
                background: "red",
            });
        }

    };

    /** Sélection conteneur + sauvegarde localStorage */
    const handleSelectConteneur = (c) => {
        setConteneur(c);
        setProducts(c?.produits || null);
        encryptData("selectedConteneur", c);
    };



    const handlePrix = (e, prod) => {
        prod.pvu = e.target.value.replace(/\D/g, "");
        encryptData('selectedConteneur', conteneur)
    }


    /** Totaux */
    const totalQte = products?.reduce(
        (previous, current) => previous + (current.quantite || 0),
        0
    );

    const totalVente = products?.reduce(
        (previous, current) => previous + (current.quantite || 0) * (current.pvu || 0),
        0
    );
    // Synchronisation localStorage
    useEffect(() => {
        if (conteneur) {
            encryptData("selectedConteneur", conteneur);
        }
    }, [conteneur, products]);

    /** Vérification utilisateur */
    const user = decryptData("USER");
    if (user?.droit !== "Administrateur") {
        Swal.fire({
            title: "Accès non autorisé",
            icon: "error",
        }).then(() => navigate("/login"));
        return null;
    }

    return (
        <div className="AddApprovision">
            {(isLoading || isloading) && <div className="loader"></div>}
            <div className="row my-2">
                <div className="col-lg-8 h3 text-primary">
                    APPROVISIONNER UN MAGASIN
                </div>
            </div>

            <div className="row">
                {/* Magasin */}
                <div className="col-lg-6 form-group">
                    <label>Magasin</label>

                    <Select
                        value={
                            magasin
                                ? {
                                    value: magasin.value,
                                    label: magasin.label,
                                    ...magasin, // pour garder les autres props
                                }
                                : null
                        }
                        options={magasins.map((m) => ({
                            ...m,
                            value: m.id,
                            label: m.magasin,
                        }))}
                        onChange={setMagasin}
                    />

                </div>

                {/* Conteneur */}
                <div className="col-lg-6">
                    <label>Conteneurs</label>


                    <Select
                        value={
                            conteneur
                                ? {
                                    value: `${conteneur.id}`,
                                    label: conteneur.conteneur,
                                    ...conteneur, // pour garder les autres props
                                }
                                : null
                        }
                        options={conteneurs.map((cont) => ({
                            ...cont,
                            value: `${cont.id}`,
                            label: `${cont.conteneur}`,
                        }))}
                        onChange={handleSelectConteneur}
                    />

                </div>
            </div>

            {/* Informations conteneur */}
            <div className="row">
                {conteneur && (
                    <div className="row">
                        <div className="col-sm-6 my-1">
                            <label>Montant facture en devise</label>
                            <input
                                type="text"
                                disabled
                                className="form-control"
                                value={`${(+conteneur?.Prix || 0).toLocaleString()} ${conteneur?.devise || ""
                                    }`}
                            />
                        </div>

                        <div className="col-sm-6 my-1">
                            <label>Montant facture en GNF</label>
                            <input
                                type="text"
                                disabled
                                className="form-control"
                                value={`${((conteneur?.Prix || 0) * (conteneur?.valeur_du_jour || 0)).toLocaleString()} GNF`}
                            />
                        </div>

                        <div className="col-sm-6 my-1">
                            <label>Dépense totale (GNF)</label>
                            <input
                                type="text"
                                disabled
                                className="form-control"
                                value={`${(+conteneur?.depense || 0).toLocaleString()} GNF`}
                            />
                        </div>

                        <div className="col-sm-6 my-1">
                            <label>Montant total (GNF)</label>
                            <input
                                type="text"
                                disabled
                                className="form-control"
                                value={`${(+conteneur?.Montant || 0).toLocaleString()} GNF`}
                            />
                        </div>

                        <div className="col-sm-6 my-1">
                            <label>Montant d'achat (GNF)</label>
                            <input
                                type="text"
                                disabled
                                className="form-control"
                                value={`${(+conteneur?.montant_achat || 0).toLocaleString()} GNF`}
                            />
                        </div>

                        <div className="col-sm-6 my-1">
                            <label>Bénéfice (GNF)</label>
                            <input
                                type="text"
                                disabled
                                className="form-control"
                                value={`${((+conteneur?.montant_achat || 0) - (+conteneur?.Montant || 0)).toLocaleString()} GNF`}
                            />
                        </div>
                    </div>
                )}
            </div>


            {/* Produits */}
            {products ? (
                <div className="row table-responsive mt-2 shadow">
                    <table
                        className="table table-striped table-hover table-bordered"
                        ref={printElemet}
                    >
                        <thead className="table-dark border-white text-center">
                            <tr>
                                <th>N°</th>
                                <th>Produit</th>
                                <th>Quantité</th>
                                <th>PAU</th>
                                <th>MONTANT PAU</th>
                                <th className="text-end">PVU (GNF)</th>
                            </tr>
                        </thead>

                        <tbody>
                            {products.map((prod, index) => (
                                <tr key={index + 1}>
                                    <td>{index + 1}</td>
                                    <td>{prod.produit}</td>
                                    <td>{prod.quantite}</td>
                                    <td>{`${(+prod.pau || 0).toLocaleString()} GNF`}</td>
                                    <td>{`${((+prod.pau || 0) * (prod.quantite || 0)).toLocaleString()} GNF`}</td>
                                    <td className="text-end">
                                        <input defaultValue={parseFloat(prod.pvu).toLocaleString()}
                                            type="text"
                                            className="form-control prix"
                                            placeholder="Prix de vente unitaire"
                                            onChange={(e) => handlePrix(e, prod)}

                                            onBlur={(e) => formatMoney(e)}
                                            onFocus={(e) => onfocus(e)}
                                        />
                                    </td>
                                </tr>
                            ))}

                            <tr>
                                <td colSpan={2} className="fs-3 fw-bold text-center">
                                    Totaux
                                </td>
                                <td className="fw-bold">{totalQte}</td>
                                <td className="text-center">-</td>
                                <td className="fw-bold">
                                    {conteneur?.montant_achat?.toLocaleString()} GNF
                                </td>
                                <td className="fw-bold" hidden>
                                    {totalVente?.toLocaleString()} GNF
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="row my-2 justify-content-end">
                        <div className="col-lg-4 text-center">
                            <button className="btn btn-danger m-1" onClick={handleCancel}>
                                Annuler
                            </button>
                            <button
                                className="btn btn-success m-1"
                                onClick={handleSave}
                                disabled={isLoading}
                            >
                                Enregistrer
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="row"></div>
            )}
        </div>
    );
};

export default AddApprovision;
